module.exports = __webpack_public_path__ + "img/product-6.4cfff55d.jpg";